function isRyanairAirline(airlineName: string): boolean {
  return airlineName.toLowerCase() === 'ryanair'
}

export function shouldShowRyanairBanner(airlinesNames: string[]): boolean {
  return airlinesNames.some(isRyanairAirline)
}

export function shouldShowConfirmationPopupIfAirlinesAreNotRyanair(airlinesNames: string[]): boolean {
  if (!airlinesNames)
    return true

  return !airlinesNames.some(isRyanairAirline)
}

export function shouldShowRyanairTermsAndConditions(airlinesNames: string[]): boolean {
  return airlinesNames.some(isRyanairAirline)
}

export function getAirlineNameIfAllAirlinesAreTheSame(airlinesNames: string[]): string | null {
  if (!airlinesNames || airlinesNames.length === 0 || airlinesNames.some(name => !name.trim()))
    return null

  const firstAirlineName = airlinesNames[0]
  const allAirlinesAreTheSame = airlinesNames.every(name => name === firstAirlineName)

  return allAirlinesAreTheSame ? firstAirlineName : null
}
